import type { TFunction } from 'i18next';
import { HttpError } from '../services/apiClient';

/**
 * Translates an HttpError using its server-provided `code` and `params` against the
 * `apiErrors.<code>` namespace. Falls back to the server's English `message` (or the
 * raw error message) when the error carries no code or the key isn't in the catalog.
 */
export function localizeApiError(error: unknown, t: TFunction): string {
    if (error instanceof HttpError && error.code) {
        const key = `apiErrors.${error.code}`;
        const translated = t(key, { ...(error.params ?? {}), defaultValue: '' });
        if (translated) return translated;
    }
    if (error instanceof Error) return error.message;
    return t('apiErrors.generic');
}
